export default "__VITE_ASSET__ac6fdd3a__"